(() => {
  if (customElements.get('lumiva-cart-items')) return;

  class LumivaCartItems extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.busy = false;
      this.addEventListener('input', (event) => {
        if (!event.target.matches('.quantity__input')) return;
        clearTimeout(this.quantityTimer);
        this.quantityTimer = setTimeout(() => this.changeQuantity(event.target, Number(event.target.value)), 300);
      });
      this.addEventListener('change', (event) => {
        if (!event.target.matches('.quantity__input')) return;
        clearTimeout(this.quantityTimer);
        event.stopPropagation();
        this.changeQuantity(event.target, Number(event.target.value));
      });
      this.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-cart-remove]');
        if (!remove) return;
        event.preventDefault();
        event.stopPropagation();
        const input = remove.closest('.cart-item').querySelector('.quantity__input');
        this.changeQuantity(input, 0);
      }, true);
      this.addEventListener('submit', (event) => {
        if (this.busy && event.target.id === 'cart') event.preventDefault();
      });
    }

    setBusy(value) {
      this.busy = value;
      this.setAttribute('aria-busy', String(value));
      this.querySelectorAll('.quantity__input, .quantity__button, [data-cart-remove]').forEach((element) => {
        element.disabled = value;
        element.setAttribute('aria-disabled', String(value));
      });
      const checkout = document.querySelector('[name="checkout"][form="cart"]');
      if (checkout) checkout.disabled = value || this.classList.contains('is-empty');
    }

    async changeQuantity(input, quantity) {
      if (this.busy || !input) return;
      const previous = input.getAttribute('value');
      if (!Number.isInteger(quantity) || quantity < 0 || (quantity > 0 && !input.checkValidity())) {
        input.value = previous;
        input.reportValidity();
        return;
      }
      const error = document.getElementById('cart-errors');
      if (error) error.textContent = '';
      const itemSection = document.getElementById('main-cart-items').dataset.id;
      const footerSection = document.getElementById('main-cart-footer').dataset.id;
      this.setBusy(true);
      let saved = false;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: input.dataset.cartKey,
            quantity,
            sections: [itemSection, footerSection, 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
        const cart = await response.json();
        if (!response.ok || cart.errors) throw new Error(cart.description || cart.message || cart.errors || 'Your cart could not be updated. Please try again.');
        saved = true;
        const parser = new DOMParser();
        const items = parser.parseFromString(cart.sections?.[itemSection] || '', 'text/html').querySelector('lumiva-cart-items');
        const footer = parser.parseFromString(cart.sections?.[footerSection] || '', 'text/html').getElementById('main-cart-footer');
        const bubble = parser.parseFromString(cart.sections?.['cart-icon-bubble'] || '', 'text/html');
        if (!items || !footer) {
          window.location.reload();
          return;
        }
        this.innerHTML = items.innerHTML;
        this.classList.toggle('is-empty', cart.item_count === 0);
        document.getElementById('main-cart-footer').innerHTML = footer.innerHTML;
        document.getElementById('main-cart-footer').closest('.shopify-section')?.classList.toggle('is-empty', cart.item_count === 0);
        const icon = document.getElementById('cart-icon-bubble');
        const iconContent = bubble.querySelector('.shopify-section');
        if (icon && iconContent) icon.innerHTML = iconContent.innerHTML;
        const status = document.getElementById('cart-live-region-text');
        if (status) status.textContent = `Cart updated. ${cart.item_count} items.`;
        const updated = Array.from(this.querySelectorAll('.quantity__input')).find((element) => element.dataset.cartKey === input.dataset.cartKey);
        updated?.focus({ preventScroll: true });
      } catch (failure) {
        if (saved) {
          window.location.reload();
          return;
        }
        input.value = previous;
        const message = document.getElementById('cart-errors');
        if (message) {
          message.setAttribute('role', 'alert');
          message.textContent = failure.message || 'Your cart could not be updated. Please try again.';
        }
      } finally {
        this.setBusy(false);
      }
    }
  }

  customElements.define('lumiva-cart-items', LumivaCartItems);
})();